var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['skeleton-data-item'],style:(_vm.styles)},[_c('div',{class:_vm.$style['skeleton-data-item__label']}),_c('div',{class:_vm.$style['skeleton-data-item__value']})])
}
var staticRenderFns = []

export { render, staticRenderFns }